module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_5.6442cc7a.png";